const about = [
    {
        key: 1,
        img:"./backend2.png?",
        name: "Backend Developer",
        description: "I am an agile backend developer with expertise in a wide range of technologies. I love to code and solve problem",
        h1: "Technologies I use:",
        h1Array: ['Node.js', 'MongoDB', 'Golang', 'NET', 'Python', 'Opensips', 'cGrates', 'gRPC'],
        h2: "Dev Tools:",
        h2Array: ['VSCode', 'Visual Studio Code', 'Postman', 'Terminal', 'Ngrok', 'Git', 'Github']
    },
    {
        key: 2,
        img:"./frontend2.png",
        name: "Frontend Developer",
        description: "I do frontend development to give screen to my backend projects and my imagination.",
        h1: "Technologies I use:",
        h1Array: ['HTML', 'CSS', 'Hugo', 'JS', 'React.js'],
        h2: "Dev Tools:",
        h2Array: ['VSCode', 'Bootstrap', 'Terminal', 'Git', 'Github', 'Gitlab', 'Visual StudioCode', 'Netlify', 'Heroku']
    },
    {
        key: 3,
        img:"./buse.png",
        name: "Bundura University of Science and Education",
        description: "I am a Graduate of Information Technology at Bindura University.",
        h1: "What I study:",
        h1Array: ['Software Engineering'],
        h2: "Things I Do:",
        h2Array: ['Development', 'Coding', 'Projects', 'Make Friends', 'Networking', 'Mentor Juniors', 'Research', 'Reading'],
    },
    {
        key: 4,
        img:"./africom.png",
        name: "Africom Pvt Ltd",
        description: "I am an Engineer at Africom Pvt Ltd, specializing in backend development.",
        h1: "What I Do:",
        h1Array: ['Project Management', 'Development', 'Coding', 'DevOps', 'Backend Development', 'Frontend Development', 'Technical Research', 'LTE Network Monitoring', 'LTE Network Maintenance', 'LTE Network Support'],
        h2: "Technologies Used:",
        h2Array: ['Golang', 'Python', 'Flutter', 'Firebase', 'Opensips', 'Cgrates (OCS)', 'Hugo', 'Node Js', 'C++', 'MySQL', 'Mongo', 'Git'],
    },
    {
        key: 5,
        img:"./durihub.png",
        name: "DuriHub Pvt Ltd",
        description: "I am an Full Stack Developer at Duri Hub.",
        h1: "What I Do:",
        h1Array: ['Software Development', 'Project Management', 'Development', 'Coding', 'DevOps', 'Backend Development', 'Frontend Development', 'Technical Research', 'Mobile Development', 'VoIP Calls Management', 'Call Routing', 'Billing System Management', 'Billing System Maintenance'],
        h2: "Technologies Used:",
        h2Array: [ 'Golang', 'Python', 'Flutter', 'Firebase', 'Opensips', 'Cgrates (OCS)', 'Hugo', 'Node Js', 'Magma', 'Docker', 'Redpanda', 'ClickHouse', 'MySQL', 'Mongo', 'gRPC', 'Git'],
    },
    {
        key: 6,
        img:"./umbai.png",
        name: "Umbai Africa",
        description: "I am Developer at Umbai Africa.",
        h1: "What I Do:",
        h1Array: ['Development'],
        h2: "Technologies Used:",
        h2Array: [ 'C#', 'Vue Js', 'MySQL','Git', 'Github', 'Gitlab', 'Visual Studio Code', 'Swagger','Postman', 'Db-Heaver', 'MySQL'],

    }
    
]

export default about